import { type Step, type TanstackUrl, getCurrentStepIndex } from '@/lib/stepper.ts';
import { CATEGORY_TYPE, type CategoryType, type ProductCategory } from '@/types/product.type.ts';

export type ProductStep = Step & {
  categoryType?: CategoryType;
};

export const PRODUCT_STEP_ID_SUMMARY = 'Summary';
export const PRODUCT_STEP_URL_SUMMARY = '/products/summary';
export const PRODUCT_STEP_URL_NO_PRODUCTS_SELECTED = '/products/no-products-selected';

// TODO This will probably remain but be filtered by the patient's
//  allowed products based on their insurance plan
export const PRODUCT_STEPS: ProductStep[] = [
  {
    id: 'Incontinence',
    name: 'Incontinence',
    description: 'categories',
    url: '/products/incontinence',
    categoryType: CATEGORY_TYPE.INCONTINENCE,
  },
  {
    id: 'Mobility',
    name: 'Mobility',
    description: 'categories',
    url: '/products/mobility',
    categoryType: CATEGORY_TYPE.MOBILITY,
  },
  {
    id: 'Diabetes',
    name: 'Diabetes',
    description: 'categories',
    url: '/products/diabetes',
    categoryType: CATEGORY_TYPE.DIABETES,
  },
  {
    id: 'Home Accessibility',
    name: 'Accessibility',
    description: 'categories',
    url: '/products/accessibility',
    categoryType: CATEGORY_TYPE.ACCESSIBILITY,
  },
  {
    id: 'Nutrition',
    name: 'Nutrition',
    description: 'categories',
    url: '/products/nutrition',
    categoryType: CATEGORY_TYPE.NUTRITION,
  },
  {
    id: PRODUCT_STEP_ID_SUMMARY,
    name: 'Summary',
    url: PRODUCT_STEP_URL_SUMMARY,
    hideStepCount: true,
  },
];

/** Map persisted category UUIDs to `ProductCategory.label` values (aligned with `ProductStep.id`). */
export function categoryIdsToLabels(
  ids: string[],
  categories: ProductCategory[] | undefined
): string[] {
  if (!categories?.length || !ids.length) return [];
  const byUuid = new Map(categories.map((c) => [c.uuid, c.label]));
  return ids.map((id) => byUuid.get(id)).filter((label): label is string => label != null);
}

export function getNextProductStepUrl(selectedCategoryLabels: string[]): TanstackUrl {
  const steps = PRODUCT_STEPS.filter(
    (step) => step.id !== PRODUCT_STEP_ID_SUMMARY && selectedCategoryLabels.includes(step.id)
  );
  if (steps.length === 0) return PRODUCT_STEP_URL_SUMMARY;

  const stepIndex = getCurrentStepIndex(steps);
  if (stepIndex === -1) {
    if (window.location.pathname === PRODUCT_STEP_URL_SUMMARY) {
      return PRODUCT_STEP_URL_SUMMARY;
    }
    return steps[0]!.url;
  }

  const following = steps[stepIndex + 1];
  return following ? following.url : PRODUCT_STEP_URL_SUMMARY;
}

export const BLOOD_PRESSURE_MONITOR_NAME = 'Blood Pressure Monitor';
